import { Instance } from "mobx-state-tree"
import { PlayerStatsEntityModelBase } from "./PlayerStatsEntityModel.base"

/* The TypeScript type of an instance of PlayerStatsEntityModel */
export interface PlayerStatsEntityModelType extends Instance<typeof PlayerStatsEntityModel.Type> {}

/* A graphql query fragment builders for PlayerStatsEntityModel */
export { selectFromPlayerStatsEntity, playerStatsEntityModelPrimitives, PlayerStatsEntityModelSelector } from "./PlayerStatsEntityModel.base"

/**
 * PlayerStatsEntityModel
 */
export const PlayerStatsEntityModel = PlayerStatsEntityModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
